export const QUOCGIA_SET_LIST_DATA = 'QUOCGIA_SET_LIST_DATA';
export const QUOCGIA_SET_LIST_META = 'QUOCGIA_SET_LIST_META';
export const QUOCGIA_TITLE = 'Quốc gia';